<script setup lang="ts">
import { ElIcon } from 'element-plus'

import LoadingIcon from '../../assets/icons/loading.svg?component'

import FlexComponent from './FlexComponent.vue'

withDefaults(defineProps<{ size?: number; isFullSize?: boolean }>(), { size: 24, isFullSize: false })
</script>

<template>
  <FlexComponent :class="['container', { full: isFullSize }]" align="center" justify="space-around">
    <ElIcon :size="size">
      <LoadingIcon />
    </ElIcon>
  </FlexComponent>
</template>

<style scoped lang="scss">
.container {
  width: 100%;
  height: 100%;

  &.full {
    height: calc(100vh - 72px);
  }
}
</style>
